import i18next from "./i18n";
import { DEFAULT_MIVO_LOCALE, type MivoTranslationKey } from "./ITranslation";
import { resolveTranslationLanguage } from "./getTranslation";
import { resolveInitialLocale } from "./localeStorage";
import { getIsMultiLanguageEnabled } from "./multiLanguageGate";
import { DEFAULT_MARKET_COUNTRY, type MarketCountry } from "./marketCountry";
import { readStoredMarketCountry } from "./marketCountryStorage";

/** Active UI locale for registration audit fields; falls back to cookie/storage then pt-BR. */
export function resolveEffectiveRegistrationLocale(): MivoTranslationKey {
  if (i18next.isInitialized && i18next.language) {
    return resolveTranslationLanguage(i18next.language);
  }

  return resolveInitialLocale();
}

export function buildRegistrationLocalePayload(): {
  acceptedLocale: MivoTranslationKey;
  preferredLocale: MivoTranslationKey;
  marketCountry: MarketCountry;
} {
  if (!getIsMultiLanguageEnabled()) {
    return {
      acceptedLocale: DEFAULT_MIVO_LOCALE,
      preferredLocale: DEFAULT_MIVO_LOCALE,
      marketCountry: DEFAULT_MARKET_COUNTRY,
    };
  }

  const locale = resolveEffectiveRegistrationLocale();

  return {
    acceptedLocale: locale,
    preferredLocale: locale,
    marketCountry: readStoredMarketCountry(),
  };
}
